<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', permissao)">
      >
      <v-card v-if="item" :loading="salvando">
        <v-card-title> Vincular Rotina </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-select
                    v-model="item.rotina.id"
                    :items="itensRotina"
                    :rules="[obrigatorio]"
                    :disabled="operacao === 'editar'"
                    label="Rotina"
                    required
                    multiple
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="item.operacoes"
                    :items="itensAcoes"
                    :rules="[obrigatorio]"
                    label="Operações Permitidas"
                    required
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(item)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Rotina from '@/models/rotina'
import PermissaoService from '@/services/usuario/permissao'
import { obrigatorio } from '@/shareds/regrasForm'

export default {
  props: ['showDialogVinculo', 'permissao', 'rotina', 'itensRotina', 'operacao'],
  data: () => ({
    dialog: false,
    itensAcoes: [
      { text: 'Acessar', value: 'ACESSAR', disabled: true },
      { text: 'Adicionar', value: 'ADICIONAR' },
      { text: 'Editar', value: 'EDITAR' },
      { text: 'Remover', value: 'REMOVER' }
    ],
    item: {
      rotina: new Rotina(),
      operacoes: ['ACESSAR']
    },
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false
  }),

  watch: {
    showDialogVinculo() {
      this.showMessageError = false
      return this.showDialogVinculo ? (this.dialog = this.showDialogVinculo) : ''
    },

    dialog() {
      return this.dialog ? true : this.fecharDialog()
    },

    rotina() {
      return this.rotina ? (this.item = this.rotina) : ''
    }
  },

  methods: {
    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      const rotinasIdArray = item.rotina.id instanceof Array ? item.rotina.id : [item.rotina.id]

      try {
        const rotinaVinculada = await PermissaoService.addRotinaRelationship(this.permissao.id, {
          rotinas: rotinasIdArray,
          operacoes: this.item.operacoes
        })
        this.$emit('confirmado', rotinaVinculada)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$refs.formDialog.reset()
      this.$emit('update:showDialogVinculo', false)
    }
  }
}
</script>
